import router from '@/shared/router'
import { formataRotasGlobais } from '@/shared/common/functions/roteamento'
import routesParceiro from '../../parceiro/router/routes'
// Agenda (GCK-19294): reusa o module agenda com as restrições do portal
// (canal de envio só e-mail — flag contextoContador via $urlBase no Formulario)
import agendamentos from '@/modules/agenda/domains/agendamentos/router/routes'
import situacoes from '@/modules/agenda/domains/situacoes/router/routes'

import lojas from '@/domains/configuracoes/lojas/router/routes'
import usuarios from '@/domains/configuracoes/usuarios/router/routes'
import gruposUsuarios from '@/domains/configuracoes/grupos_usuarios/router/routes'
import usuariosLogs from '@/domains/relatorios/usuarios_logs/router/routes'
import permissoes from '@/domains/configuracoes/permissoes/router/routes'
import dominios from '@/domains/configuracoes/dominios/router/routes'
import ajuda from '@/domains/auxiliares/ajuda/router/routes'
import videosTutoriais from '@/domains/auxiliares/videos_tutoriais/router/routes'
import backupDados from '@/domains/configuracoes/backup_dados/router/routes'
// GCK-20890 (E-08/E-09): telas globais que o topo do portal já linkava com o prefixo
// `/contabilidade` mas que não tinham rota registrada aqui — o link caía na página
// "Oops!". Conteúdo é o mesmo do ERP; o que muda é o contexto da sessão (Auth.Contador).
import atualizacoes from '@/domains/auxiliares/atualizacoes/router/routes'
import exclusaoDados from '@/domains/configuracoes/exclusao_dados/router/routes'

let childrenRoutes = []
const paths = require.context('../domains/', true, /routes.js$/i)
const context = paths.keys().map(paths).map(m => m.default)

context.map((arr) => {
    if (arr) {
        arr.map((val) => { childrenRoutes.push(val) })
    }
})

const routes = [
    {
        path: '/contabilidade',
        component: () => import('@/shared/components/layout/Interno'),
        children: childrenRoutes.concat(agendamentos).concat(situacoes),
    },
    {
        path: '/contabilidade/sistema/acessar_erp',
        component: () => import('../domains/sistema/components/AcessarErp'),
        meta: { 
            public: true 
        }
    },
    {
        path: '/contabilidade/cadastro',
        alias: '/parceiro/cadastro',
        component: () => import('../domains/cadastro/views/Cadastro'),
        meta: { 
            public: true 
        }
    },
    ...formataRotasGlobais('contabilidade', dominios),
    ...formataRotasGlobais('contabilidade', lojas),
    ...formataRotasGlobais('contabilidade', usuarios),
    ...formataRotasGlobais('contabilidade', usuariosLogs),
    ...formataRotasGlobais('contabilidade', gruposUsuarios),
    ...formataRotasGlobais('contabilidade', permissoes),
    ...formataRotasGlobais('contabilidade', ajuda),
    ...formataRotasGlobais('contabilidade', videosTutoriais),
    ...formataRotasGlobais('contabilidade', atualizacoes),
    ...formataRotasGlobais('contabilidade', exclusaoDados),
    ...formataRotasGlobais('contabilidade', backupDados),
]

router.addRoutes(routes.concat(routesParceiro))

export default router
